import useSWR from 'swr'

import useQuery from '../context/useQuery'
import { parseMarketCode, parseMarketFromPath, type Market, getMarket } from '../lib/markets'
import { fetchVisitorCountry } from '../lib/visitorGeo'
import { useLocation } from 'react-router-dom'

/**
 * Resolves US / UK / CA / ES / AU market for localized marketing copy.
 * Priority: ?country= → path (/us, /uk, /ca) → GET /api/geo (Cloudflare CF-IPCountry).
 */
export function useVisitorMarket(): {
  market: Market | null
  isLoading: boolean
} {
  const location = useLocation()
  const params = useQuery()

  const queryMarket = parseMarketCode(params.get('country'))
  const pathMarket = parseMarketFromPath(location.pathname)
  const overrideMarket = getMarket(queryMarket ?? pathMarket ?? null)

  const { data, isLoading } = useSWR(
    overrideMarket ? null : 'visitor-geo',
    fetchVisitorCountry,
    { revalidateOnFocus: false }
  )

  const geoMarket = getMarket(data?.countryCode)
  const market = overrideMarket ?? geoMarket

  return {
    market,
    isLoading: !overrideMarket && isLoading,
  }
}
